import { ParsePriceBand } from "../parsers";

export const CalcAtNodePrice = (price, mlf) =>
  ParsePriceBand(ParsePriceBand(price) / parseFloat(mlf));
